module.exports = __webpack_public_path__ + "img/illustrator-work.dd906efa.svg";